import React, { useState } from 'react'
import { Agency, Wizard } from './Components'
import { useQuery } from '@tanstack/react-query'
import { fetchOpenings } from './Functions'
import { getUrlParams } from '@Common/Services'
import { MobileWizard } from './ComponentsMobile'
import { useWindowSize } from 'react-use'
import { Spinner } from '@Common/Components'

const NewAppointment = () => {
  const [labelNumber, setLabelNumber] = useState(0)
  const [displayCalendar, setDisplayCalendar] = useState('')
  const [calendar, setCalendar] = useState('')
  const [calendarId, setCalendarId] = useState('')
  const [date, setDate] = useState('')
  const [dateId, setDateId] = useState('')
  const [appointmentType, setAppointmentType] = useState('')
  const [displayAppointmentType, setDisplayAppointmentType] = useState('')
  const [range, setRange] = useState('')
  const [displayRange, setDisplayRange] = useState('')
  const [avatar, setAvatar] = useState('')
  const [formData, setFormData] = useState({})

  const agencyCode = getUrlParams('agency')
  const { isSuccess, data: agency = {} } = useQuery(['agencySchedule', agencyCode], fetchOpenings(agencyCode), { enabled: !!agencyCode })
  const { width: screenWidth, height: screenHeight } = useWindowSize()

  const wizardProps = {
    labelNumber: [labelNumber, setLabelNumber],
    displayCalendar: [displayCalendar, setDisplayCalendar],
    calendar: [calendar, setCalendar],
    calendarId: [calendarId, setCalendarId],
    date: [date, setDate],
    dateId: [dateId, setDateId],
    appointmentType: [appointmentType, setAppointmentType],
    displayAppointmentType: [displayAppointmentType, setDisplayAppointmentType],
    range: [range, setRange],
    displayRange: [displayRange, setDisplayRange],
    formData: [formData, setFormData],
    avatar: [avatar, setAvatar]
  }

  if (!isSuccess) return <Spinner />
  return (screenHeight > 700 && screenWidth > 1000)
    ? (
      <>
        <Agency agency={agency} />
        <Wizard agency={agency} agencyCode={agencyCode} {...wizardProps} />
      </>)
    : <MobileWizard width={screenWidth} agency={agency} {...wizardProps} />
}
export default NewAppointment
